/**
 * CSV関連のユーティリティ関数
 * (今後はCSVの処理をPapaparseに移行する予定です)
 */

/**
 * CSV文字列を行データへ変換する
 * @param csvText CSV文字列
 * @return 行データ
 */
// eslint-disable-next-line complexity -- 今後Papaparseに移行する予定のため、現状は複雑なロジックを許容する
export const parseCsvRows = (csvText: string): string[][] => {
  const normalizedText = csvText.replace(/^\uFEFF/, "");
  const rows: string[][] = [];
  let currentRow: string[] = [];
  let currentValue = "";
  let inQuotes = false;

  for (let index = 0; index < normalizedText.length; index += 1) {
    const currentChar = normalizedText[index] ?? "";
    const nextChar = normalizedText[index + 1] ?? "";

    if (currentChar === '"') {
      if (inQuotes && nextChar === '"') {
        currentValue += '"';
        index += 1;
        continue;
      }

      inQuotes = !inQuotes;
      continue;
    }

    if (!inQuotes && currentChar === ",") {
      currentRow.push(currentValue);
      currentValue = "";
      continue;
    }

    if (!inQuotes && (currentChar === "\n" || currentChar === "\r")) {
      if (currentChar === "\r" && nextChar === "\n") {
        index += 1;
      }

      currentRow.push(currentValue);
      rows.push(currentRow);
      currentRow = [];
      currentValue = "";
      continue;
    }

    currentValue += currentChar;
  }

  if (inQuotes) {
    throw new Error("CSVファイルの形式が不正です。");
  }

  if (currentValue.length > 0 || currentRow.length > 0) {
    currentRow.push(currentValue);
    rows.push(currentRow);
  }

  return rows;
};

/**
 * CSVセルをエスケープする
 * @param value セル値
 * @return エスケープ済み文字列
 */
const escapeCsvValue = (value: string) => {
  // 改行コードをスペースに置換する
  let safeValue = value.replace(/\r\n|\r|\n/g, " ");

  if (/^[=+\-@]/.test(safeValue)) {
    safeValue = "'" + safeValue;
  }

  return `"${safeValue.replace(/"/g, '""')}"`;
};

/**
 * ヘッダーと行データからCSV文字列を生成する
 * @param headers ヘッダー一覧
 * @param rows 行データ
 * @return CSV文字列
 */
export const buildCsvText = (headers: string[], rows: string[][]) => {
  return [
    headers.join(","),
    ...rows.map((row) => row.map((value) => escapeCsvValue(value ?? "")).join(",")),
  ].join("\n");
};
